module.exports = __webpack_public_path__ + "img/2-8502.e8bf01ab.png";